import api from '@motionelements/core/src/api/base-api-v2.js';
import { snakeCaseKeys } from '@motionelements/core/src/helpers/string.js';

export const getCategoryPage = async (id, mediaType) => {
  const params = {
    mediaType: mediaType,
  };
  return api.get(`/v2/categories/${id}`, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(params),
    },
  });
};

const LIST_CATEGORIES_FIELDS = 'id,html.url,url,name,thumbnails,type';

export const listCategories = async (mediaType, params = {}) => api.get('/v2/categories', {
  params: {
    ...api.getLocaleParams(),
    ...snakeCaseKeys({
      ...params,
      media_type: mediaType.replace('-', '_'),
      fields: LIST_CATEGORIES_FIELDS,
    }),
  },
});
